import React, { useState } from "react";
import cn from "classnames";
import styles from "./Settings.module.sass";
import Dropdown from "../../../components/Dropdown";
import Checkbox from "../../../components/Checkbox";

// Options pour le tri
const sortingOptions = ["Plus récents", "Plus anciens"];

const Settings = ({ onFiltersChange }) => {
  const [sorting, setSorting] = useState(sortingOptions[0]);
  const [newStatus, setNewStatus] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    applyFilters();
  };

  const handleNewStatusChange = () => {
    setNewStatus(!newStatus);
  };

  const resetFilters = () => {
    setSorting(sortingOptions[0]);
    setNewStatus(false);
    if (onFiltersChange) {
      onFiltersChange({
        sorting: sortingOptions[0],
        newStatus: false
      });
    }
  };

  const applyFilters = () => {
    console.log('Filtres appliqués:', {
      sorting,
      newStatus
    });
    
    if (onFiltersChange) {
      onFiltersChange({
        sorting,
        newStatus
      });
    }
  };

  return (
    <div className={styles.settings}>
      <div className={styles.group}>
        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={sorting}
            setValue={setSorting}
            options={sortingOptions}
            label="Trier par"
          />
        </div>
        <div className={styles.item}>
          <div className={styles.label}>Filtres</div>
          <div className={styles.list}>
            <Checkbox
              className={styles.checkbox}
              content="Statut Nouveau"
              value={newStatus}
              onChange={handleNewStatusChange}
              reverse
            />
          </div>
        </div>
        <div className={styles.btns}>
          <button 
            className={cn("button-stroke", styles.button)}
            onClick={resetFilters}
          >
            Réinitialiser
          </button>
          <button 
            className={cn("button", styles.button)}
            onClick={applyFilters}
          >
            Appliquer
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
